import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-[#EDE8E3]">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Logo & About */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_finance-portal-237/artifacts/51c1ld3v_Logo%20White.png"
                alt="UK Stage"
                className="h-12 w-auto"
                style={{
                  filter: 'brightness(0) saturate(100%) invert(16%) sepia(6%) saturate(340%) hue-rotate(314deg) brightness(96%) contrast(90%)'
                }}
              />
            </Link>
            <p className="text-sm text-[#3D3D3D] leading-relaxed">
              Building economic platforms that stand the test of time.
            </p>
          </div>

          {/* About Us */}
          <div>
            <h3 className="text-sm text-[#2A2A2A] uppercase tracking-widest mb-4">ABOUT US</h3>
            <ul className="space-y-2">
              <li><Link to="/the-team" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">The Team</Link></li>
              <li><Link to="/advisory-board" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">Advisory Board</Link></li>
              <li><Link to="/join-us" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">Join Us</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm text-[#2A2A2A] uppercase tracking-widest mb-4">QUICK LINKS</h3>
            <ul className="space-y-2">
              <li><Link to="/how-we-work" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">How We Work</Link></li>
              <li><Link to="/portfolio" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">Portfolio</Link></li>
              <li><Link to="/social-responsibility" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">Social Responsibility</Link></li>
              <li><Link to="/news" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">News</Link></li>
              <li><Link to="/contact" className="text-sm text-[#3D3D3D] hover:text-[#8B7355] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-sm text-[#2A2A2A] uppercase tracking-widest mb-4">CONNECT</h3>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="w-10 h-10 border border-[#EDE8E3] rounded-full flex items-center justify-center hover:border-[#8B7355] hover:bg-[#8B7355] transition-all duration-300 group"
              >
                <Linkedin className="w-5 h-5 text-[#3D3D3D] group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#EDE8E3] pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-[#3D3D3D] mb-4 md:mb-0">
            © 2026 UK STAGE PRIVATE LIMITED. ALL RIGHTS RESERVED.
          </p>
          <div className="flex space-x-6">
            <Link to="#" className="text-xs text-[#3D3D3D] hover:text-[#8B7355] transition-colors">PRIVACY POLICY</Link>
            <Link to="#" className="text-xs text-[#3D3D3D] hover:text-[#8B7355] transition-colors">TERMS AND CONDITIONS</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;